import { render, staticRenderFns } from "./ContactsView.vue?vue&type=template&id=844708ea&scoped=true&"
import script from "./ContactsView.vue?vue&type=script&lang=js&"
export * from "./ContactsView.vue?vue&type=script&lang=js&"
import style0 from "./ContactsView.vue?vue&type=style&index=0&id=844708ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844708ea",
  null
  
)

export default component.exports